export default "/_next/static/images/4-dcaa43bf26f04567b906610a3907c80e.png";